export { LONG_PRESS_DELAY_MS, LONG_PRESS_VIBRATION_MS } from '../../BottomNav.groups.constants';
